module.exports = __webpack_public_path__ + "img/c00_buildingtechtownwatch_Normal_ua.0fb57289.webp";